"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _UICardGrid = _interopRequireDefault(require("UIComponents/card/UICardGrid"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _ThinListing = _interopRequireDefault(require("ecosystem-marketplace-core/records/ThinListing"));

var _useResponsiveProps = require("ecosystem-marketplace-core/hooks/useResponsiveProps");

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var _requestState = require("../../../utils/requestState");

var _ResultCard = _interopRequireDefault(require("./ResultCard"));

var ResultsGrid = function ResultsGrid(_ref) {
  var onResultClick = _ref.onResultClick,
      requestState = _ref.requestState,
      resultProps = _ref.resultProps,
      results = _ref.results;
  var renderedResults = (0, _react.useMemo)(function () {
    return results.toArray().map(function (result, index) {
      return _react.default.createElement(_ResultCard.default, (0, _extends2.default)({
        key: result.id
      }, resultProps, {
        onClick: function onClick() {
          onResultClick(result, index);
        },
        result: result
      }));
    });
  }, [onResultClick, resultProps, results]);
  var responsiveProps = (0, _useResponsiveProps.useResponsiveProps)({
    columns: {
      xs: 1,
      sm: 2,
      lg: 3
    }
  });

  if (!(0, _requestState.isFulfilled)(requestState)) {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 150,
      layout: "centered"
    });
  }

  return _react.default.createElement(_UICardGrid.default, (0, _extends2.default)({
    gutterSize: 16
  }, responsiveProps), renderedResults);
};

ResultsGrid.propTypes = {
  onResultClick: _propTypes.default.func,
  requestState: CustomPropTypes.requestState,
  resultProps: _propTypes.default.object,
  results: _reactImmutableProptypes.default.iterableOf(_propTypes.default.instanceOf(_ThinListing.default)).isRequired
};
ResultsGrid.defaultProps = {
  onResultClick: _emptyFunction.default,
  resultProps: {},
  requestState: RequestState.SUCCEEDED
};
var _default = ResultsGrid;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/ResultsGrid.js
// module id = 222
// module chunks = 209 210 211 212